<template>
  <v-container fill-height class="pa-0 white">
    <v-layout row wrap v-if="filtrationSystem.filtrationSystemId">

      <!--### サイドバー   ############################################################-->
      <v-flex xs12 sm3 class="grey lighten-4" id="sidebar">
        <v-container>
          <span v-if="userRole===viewerRoleName" class="caption hidden-xs-only orange--text">{{$t('account.function-limit')}}</span>

          <div class="body-2">  {{location.locationName}}</div>
          <div class="device-setting-btn">
            <v-btn v-if="userRole!==viewerRoleName"
              class="grey--text"
              icon slot="activator" outline
              @click="openDeviceEditDialog(filtrationSystem.filtrationSystemId)"
            >
              <v-icon class="grey--text" >edit</v-icon>
            </v-btn>
            <device-edit-dialog 
                ref="deviceEditDialog"
                @child-action="getFiltrationSystem"
            />
            <v-btn v-if="userRole!==viewerRoleName" class="grey--text" icon slot="activator" outline @click.stop="showWaterSystemDeleteDialog(filtrationSystem)"><v-icon class="grey--text">delete</v-icon></v-btn>
            <water-system-delete-dialog ref="waterSystemDeleteDialog" @delete-succeed="reloadWaterSystemList"/>
          </div>
          <h1 class="mt-2 mb-2" id="device-name">{{filtrationSystem.filtrationSystemName}}</h1>
          <div class="grey lighten-2 pa-1 caption">UID:{{filtrationSystem.jm1UniqueId}}</div>
          <div class="grey lighten-2 pa-1 caption">{{$t('watersystem.last-update')}}:{{unixToDatetime(filtrationSystem.modifiedTime)}}</div>

          <div v-for="service in filtrationSystem.dispServices">

            <!-- 経過時間 -->
            <div
              v-if="service.serviceId==1"
              :class="flowAndTimeMeta.timeColor==='blue'?'':flowAndTimeMeta.timeColor+'--text'"
              class="mt-3" >
              <v-icon :class="flowAndTimeMeta.timeColor+'--text'">
                fiber_manual_record
              </v-icon>
              {{$t('watersystem.elapsed-time')}}
              <div class="ml-4">
                <span class="title">
                {{flowAndTimeMeta.fromNowMonth}} {{$t('watersystem.period-month')}}
                </span>
                <span>
                  /{{flowAndTimeMeta.maxLifeMonth}} {{$t('watersystem.period-month')}}
                </span>
              </div>
              <hr class="mt-1"/>
            </div>

            <!-- 流量 -->
            <div
              v-if="service.serviceId==1"
              :class="flowAndTimeMeta.flowColor==='blue'?'':flowAndTimeMeta.flowColor+'--text'"
              class="mt-3" >
              <v-icon :class="flowAndTimeMeta.flowColor+'--text'">
                fiber_manual_record
              </v-icon>
              {{$t('watersystem.total-flow')}}
              <div class="ml-4">
                <span class="title">
                {{flowAndTimeMeta.leftFlowFormated}}
                </span>
                <span>
                  /{{flowAndTimeMeta.maxFlowFormated}}&nbsp;{{unit}}
                </span>
              </div>
              <hr class="mt-1"/>
            </div>

            <!-- RO -->
            <div
              v-if="service.serviceId==2"
              :class="getClassNameServiceStatus(service).replace('blue--text', '')"
              class="mt-3" >
              <v-icon :class="getClassNameServiceStatus(service)">
                fiber_manual_record
              </v-icon>
              {{$t('watersystem.RoMembrane-short')}}
              <div class="ml-4">
                <span v-if="getServiceStatus(service)==2" class="title">{{$t('watersystem.RoMembrane-alert')}}</span>
                <span v-else-if="getServiceStatus(service)==1" class="title">{{$t('watersystem.RoMembrane-caution')}}</span>
                <span v-else class="title">{{$t('watersystem.RoMembrane-good')}}</span>
              </div>
              <hr class="mt-1"/>
            </div>

            <!-- 温度 -->
            <div
              v-if="service.serviceId==3"
              v-for="detail in service.details"
              :class="getClassNamePluginStatus(detail).replace('blue--text', '')"
              class="mt-3" >
              <v-icon :class="getClassNamePluginStatus(detail)">
                fiber_manual_record
              </v-icon>
              A{{detail.portNumber}} {{$t('watersystem.temperature-short')}}
              <div class="ml-4">
                <span v-if="getPluginStatus(detail)==2" class="title">
                  {{convertTemperatureUnit(detail.currentRate)}}{{' '+temperatureUnit}}
                </span>
                <span v-else-if="getPluginStatus(detail)==1" class="title">
                  {{convertTemperatureUnit(detail.currentRate)}}{{' '+temperatureUnit}}
                </span>
                <span v-else class="title">
                  {{convertTemperatureUnit(detail.currentRate)}}{{' '+temperatureUnit}}
                </span>
              </div>
              <hr class="mt-1"/>
            </div>

            <!-- 漏水 -->
            <div
              v-if="service.serviceId==4"
              v-for="detail in service.details"
              :class="getClassNamePluginStatus(detail).replace('blue--text', '')"
              class="mt-3" >
              <v-icon :class="getClassNamePluginStatus(detail)">
                fiber_manual_record
              </v-icon>
              A{{detail.portNumber}} {{$t('watersystem.leakage-short')}}
              <div class="ml-4">
                <span v-if="getPluginStatus(detail)==2" class="title">{{$t('watersystem.leakage-alert')}}</span>
                <span v-else class="title">{{$t('watersystem.leakage-normal')}}</span>
              </div>
              <hr class="mt-1"/>
            </div>

            <!-- 圧力 -->
            <div
              v-if="service.serviceId==5"
              v-for="detail in service.details"
              :class="getClassNamePluginStatus(detail).replace('blue--text', '')"
              class="mt-3" >
              <v-icon :class="getClassNamePluginStatus(detail)">
                fiber_manual_record
              </v-icon>
              A{{detail.portNumber}} {{$t('watersystem.Pressure-short')}}
              <div class="ml-4">
                <span v-if="getPluginStatus(detail)==2" class="title">{{convertPressureUnit(detail.currentRate)}}{{' '+pressureUnit}}</span>
                <span v-else-if="getPluginStatus(detail)==1" class="title">{{convertPressureUnit(detail.currentRate)}}{{' '+pressureUnit}}</span>
                <span v-else class="title">{{convertPressureUnit(detail.currentRate)}}{{' '+pressureUnit}}</span>
              </div>
              <hr class="mt-1"/>
            </div>

          </div> <!-- v-for service -->

          <!-- ロケーション情報 -->
          <div class="mt-3" id="location">
            <h3>{{$t('watersystem.customer-info')}}</h3>
            <ul id="address" class="mt-1">
              <li>{{location.locationAddress}}</li>
            </ul>
            <ul id="phone" class="mt-1">
              <li>{{location.locationPhone}}</li>
            </ul>
            <ul id="contact" class="mt-1">
              <li>{{location.organizationContact}}</li>
            </ul>
          </div>
        </v-container>
        <csv-download-dialog
          v-if="userRole!==viewerRoleName"
          :earliestLogInfo="earliestLogInfo"
          :locale="locale"
          :timezone="selectedTimezone"
          :filtrationSystemProp="filtrationSystem"
          :filterProp="filter"
        />
      </v-flex>

        <!--### メイン   ############################################################-->
        <v-flex xs12 sm9  class="white">
          <v-tabs
            v-model='activeTab'
            slider-color="white" height="30px"
            id="watersystem-tab">

            <!-- タブ -->
            <v-tab
              v-for="service in filtrationSystem.dispServices"
              :key="serviceCodes[service.serviceId]"
              :href="'#'+serviceCodes[service.serviceId]"
              active-class="white"
              >
              <v-icon :class="getClassNameServiceStatus(service)" >
               fiber_manual_record
              </v-icon>
              {{serviceNames[service.serviceId]}}
            </v-tab>
            <v-tab
              href="#HISTORY"
              @click="getHistory"
              active-class="white"
              :class="activeTab=='HISTORY'?'white':'grey lighten-3'">
                {{$t("watersystem.history")}}
            </v-tab>

            <!--  タブ コンテンツ  ######################### -->
            <template v-for="service in filtrationSystem.dispServices">
              <!-- 流量と時間 ######################################-->
              <v-tab-item id="FLOW" v-if="service.serviceId === 1" reverse-transition="false" transition="false">
                <v-container>
                  <v-layout class="pl-3">
                    <!--通知プリセット-->
                    <v-flex xs4>
                      <h6 class="grey--text">{{$t("settings.notification-presets")}}</h6>
                      <h3>{{$t('customer.undefined')}}</h3>
                    </v-flex>
                    <!--交換予測日-->
                    <v-flex xs4>
                      <h6 class="grey--text">{{$t("watersystem.column-nexttime")}}</h6>
                      <h2>{{nextReplacement(filter.nextReplacementTime)}}</h2>
                    </v-flex>
                    <!--設定ボタン disabled-->
                    <v-flex xs2>
                      <v-btn
                      small
                      outline
                      class="lighten-2 pa-0"
                      @click="openSettingDialog(service.serviceId)"
                      :disabled="frowSettingBtnDisabled || userRole===viewerRoleName"
                      >
                        <v-icon class="body-1">settings</v-icon>&nbsp;
                        <span>{{$t('settings.title')}}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <hr class="ma-3"/>

                  <v-layout row wrap>

                    <!-- フィルター寿命 -->
                    <v-flex xs12 sm6>
                      <v-layout row wrap class="pl-3 pr-3">
                        <v-flex :class="flowAndTimeMeta.flowColor+'--text'" class="caption">
                          <v-icon
                           :class="flowAndTimeMeta.flowColor+'--text'"
                           class="caption">
                            fa-tint
                          </v-icon>
                          {{$t('watersystem.rest-flow')}}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex class="text-xs-right">
                          <span :class="flowAndTimeMeta.flowColor+'--text'"
                            class="title">
                            {{flowAndTimeMeta.flowLifePercent}}%
                          </span>
                          <span class="grey--text caption">
                            {{flowAndTimeMeta.flowLifeLeft}}
                          </span>
                        </v-flex>
                        <v-flex xs12 class="ma-0">
                          <v-progress-linear
                            :value="flowAndTimeMeta.flowLifePercent"
                            height="20"
                            :color="flowAndTimeMeta.flowColor"
                            class="ma-0">
                            </v-progress-linear>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!--経過時間-->
                    <v-flex xs12 sm6>
                      <v-layout row wrap class="pl-3 pr-3"  align-baseline>
                        <v-flex :class="flowAndTimeMeta.timeColor+'--text'" class="caption">
                          <v-icon
                            :class="flowAndTimeMeta.timeColor+'--text'"
                            class="caption">
                            fa-hourglass-half
                          </v-icon>
                           {{$t('watersystem.elapsed-time')}}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex class="text-xs-right">
                          <span
                          :class="flowAndTimeMeta.timeColor+'--text'"
                           class="title">
                            {{flowAndTimeMeta.fromNowMonth}}
                            {{$t("watersystem.period-month")}}
                          </span>
                          <span class="grey--text caption">
                            /{{flowAndTimeMeta.maxLifeMonth}}
                            {{$t("watersystem.period-month")}}
                          </span>
                        </v-flex>
                        <v-flex xs12>
                            <v-progress-linear
                            :value="flowAndTimeMeta.timePercent"
                            height="20"
                            :color="flowAndTimeMeta.timeColor"
                            class="ma-0">
                            </v-progress-linear>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <hr class='ma-3'/>


                  <!-- 流量 グラフ -->
                  <v-layout row wrap>
                    <v-flex xs12>
                      <flow-log-chart
                        :data-id="filtrationSystem.filtrationSystemId + ':' + filter.configId"
                        :timezone="selectedTimezone"
                        :unit="unit"
                        :slot-num="filter.slotNumber"
                        :currentTab="currentTab"
                        :activeTab="activeTab"
                        :label-flow="$t('chart.graph-label-fromlastchange')"
                        :label-flow-diff="$t('chart.graph-label-diff')"
                        :label-flow-sum="$t('chart.graph-label-sum')"
                        :earliestLogInfo="earliestLogInfo"
                        @emit-earliest-timestamp="emitEarliestTimestamp"
                        @child-action="getFiltrationSystem"
                        >
                      </flow-log-chart>
                      <v-flex xs12>
                        <v-btn
                          small outline
                          @click="showResetDialog=true"
                          :disabled="!showForm || userRole===viewerRoleName">
                          {{$t("watersystem.filter-reset")}}
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <div>
                          <h4>{{$t("watersystem.notification-threshold")}}</h4>
                          <table class="tab-info-table" >
                            <tr>
                              <th ></th>
                              <th >{{$t("watersystem.alert")}}</th>
                              <th >{{$t("watersystem.warning")}}</th>
                            </tr>
                            <tr>
                              <td>
                                {{$t('watersystem.flow-life')}}
                              </td>
                              <td>
                                {{convertMaxLifeSpanFlow(service.filters[0].maxLifeSpanFlow)+' '+unit}}
                              </td>
                              <td>
                                {{convertMaxLifeSpanFlow(service.filters[0].warningLifeSpanFlow)+' '+unit}}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{$t('watersystem.time-life')}}
                              </td>
                              <td>
                                {{convertSecondToMonth(service.filters[0].maxLifeSpanTime)}} {{$t('watersystem.period-month')}}
                              </td>
                              <td>
                                {{convertSecondToMonth(service.filters[0].warningLifeSpanTime)}} {{$t('watersystem.period-month')}}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <div class="setting-link-text" v-if="frowSettingBtnDisabled===false && userRole!==viewerRoleName" >
                    {{$t("watersystem.setting-link-text1")}}
                    <a
                      href="#"
                      @click="openSettingDialog(service.serviceId)"
                    >
                    {{$t("watersystem.setting-link-text2")}}
                    </a>
                    {{$t("watersystem.setting-link-text3")}}
                  </div>
                </v-container>
              </v-tab-item>

              <!-- RO不純物除去率 ##################################-->

              <v-tab-item id="RO" v-if="service.serviceId === 2" reverse-transition="false" transition="false">
                <v-container class="white">
                  <v-spacer></v-spacer>
                   <!--設定ボタン disabled-->
                  <v-flex xs2>
                    <v-btn
                    small
                    outline
                    class="lighten-2 pa-0"
                    @click="openSettingDialog(service.serviceId)"
                    :disabled="roSettingBtnDisabled || userRole===viewerRoleName"
                    >
                      <v-icon class=" body-1">settings</v-icon>&nbsp;
                      <span>{{$t('settings.title')}}</span>
                    </v-btn>
                  </v-flex>

                  <ro-rate-log-chart
                    :data-id="filtrationSystem.filtrationSystemId + ':1'"
                    :timezone="selectedTimezone"
                    :activeTab="activeTab"
                    :color="getClassNameServiceStatus(service).replace('--text', '')"
                    :earliestLogInfo="earliestLogInfo"
                    @emit-earliest-timestamp="emitEarliestTimestamp"
                    @child-action="getFiltrationSystem"
                  >
                  </ro-rate-log-chart>
                  <div >
                    <h4>{{$t("watersystem.notification-threshold")}}</h4>
                    <table class="tab-info-table" >
                      <tr>
                        <th ></th>
                        <th >{{$t("watersystem.alert")}}</th>
                        <th >{{$t("watersystem.warning")}}</th>
                      </tr>
                      <tr >
                        <td>
                          {{$t("watersystem.impurities-removal-rate")}}
                        </td>
                        <td>
                          {{service.alertRate}} %
                        </td>
                        <td>
                          {{service.warningRate}} %
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="setting-link-text" v-if="roSettingBtnDisabled===false && userRole!==viewerRoleName" >
                    {{$t("watersystem.setting-link-text1")}}
                    <a
                      href="#"
                      @click="openSettingDialog(service.serviceId)"
                    >
                    {{$t("watersystem.setting-link-text2")}}
                    </a>
                    {{$t("watersystem.setting-link-text3")}}
                  </div>
                </v-container>
              </v-tab-item>

              <!-- 温度 -->
              <v-tab-item id="TEMPERA" v-if="service.serviceId === 3" reverse-transition="false" transition="false">
                <v-container class="white">
                  <div v-for="detail in service.details" >
                    <p v-if="getPluginStatus(detail)==2" >
                      <span
                        class="red--text"
                      >
                        {{'A'+detail.portNumber + ' ' + $t("sensor.temperature")+' '}}
                      </span>
                      {{getHeadlineMsg(detail.serviceId,detail.validationType,2)}}
                    </p>
                    <p v-else-if="getPluginStatus(detail)==1" >
                      <span
                        class="orange--text"
                      >
                      {{'A'+detail.portNumber + ' ' + $t("sensor.temperature")+' '}}
                      </span>
                      {{getHeadlineMsg(detail.serviceId,detail.validationType,1)}}
                    </p>
                  </div>
                  <div
                    :class="getClassNameTabInfoHeadlineNoDisp(service)"
                  >
                    <p>
                      {{$t("watersystem.temperature-normal")}}
                    </p>
                  </div>
                  <v-flex >
                    <v-btn-toggle v-model="selectTemperatureEditPort" mandatory>
                      <v-btn
                        flat
                        class="port-select-btn"
                        v-for="detail in service.details"
                        :value="detail.portNumber"
                        :key="'TEMPERA'+detail.portNumber"
                      >
                        {{'A'+ detail.portNumber}}
                      </v-btn>
                    </v-btn-toggle>
                    <v-btn
                      small
                      outline
                      class="lighten-2 pa-0"
                      @click="openSettingDialog(service.serviceId)"
                      :disabled="temperatureSettingBtnDisabled || userRole===viewerRoleName"
                    >
                      <v-icon class="body-1">settings</v-icon>&nbsp;
                      <span >{{$t('settings.title')}}</span>
                    </v-btn>
                  </v-flex>
                  <hr class="ma-3">
                  <temperature-log-chart
                    :data-id="filtrationSystem.filtrationSystemId + ':' + selectTemperatureEditPort"
                    :selectEditPort="selectTemperatureEditPort"
                    :details="service.details"
                    :timezone="selectedTimezone"
                    :activeTab="activeTab"
                    :color="getClassNameServiceStatus(service).replace('--text', '')"
                    :earliestLogInfo="earliestLogInfo"
                    @emit-earliest-timestamp="emitEarliestTimestamp"
                    @child-action="getFiltrationSystem"
                  >
                  </temperature-log-chart>
                  <div >
                    <h4>{{$t("watersystem.notification-threshold")}}</h4>
                    <table class="tab-info-table" >
                      <tr>
                        <th ></th>
                        <th >{{$t("watersystem.alert")}}</th>
                        <th >{{$t("watersystem.warning")}}</th>
                      </tr>
                      <tr v-for="detail in service.details" >
                        <td
                          v-if="detail.portNumber == selectTemperatureEditPort"
                        >
                          {{$t("service.temperature")}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectTemperatureEditPort && service.validationType===1"
                        >
                          {{convertTemperatureUnit(detail.settingData.temperature[0].alertRate.min)+' '+temperatureUnit+' '+$t("watersystem.temperature-min")}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectTemperatureEditPort && service.validationType===2"
                        >
                          {{convertTemperatureUnit(detail.settingData.temperature[0].alertRate.max)+' '+temperatureUnit+' '+$t("watersystem.temperature-max")}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectTemperatureEditPort && service.validationType===1"
                        >
                          {{convertTemperatureUnit(detail.settingData.temperature[0].warningRate.min)+' '+temperatureUnit+' '+$t("watersystem.temperature-min")}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectTemperatureEditPort && service.validationType===2"
                        >
                          {{convertTemperatureUnit(detail.settingData.temperature[0].warningRate.max)+' '+temperatureUnit+' '+$t("watersystem.temperature-max")}}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="setting-link-text" v-if="temperatureSettingBtnDisabled===false && userRole!==viewerRoleName" >
                    {{$t("watersystem.setting-link-text1")}}
                    <a
                      href="#"
                      @click="openSettingDialog(service.serviceId)"
                    >
                    {{$t("watersystem.setting-link-text2")}}
                    </a>
                    {{$t("watersystem.setting-link-text3")}}
                  </div>
                </v-container>
              </v-tab-item>

              <!-- 漏水 -->
              <v-tab-item id="LEAK" v-if="service.serviceId === 4" reverse-transition="false" transition="false">
                <v-container class="white">
                  <div v-for="detail in service.details" >
                    <p v-if="getPluginStatus(detail)==2" >
                      <span
                        class="red--text"
                      >
                        {{'A'+detail.portNumber + ' ' + $t("sensor.leakage")+' '}}
                      </span>
                      {{getHeadlineMsg(detail.serviceId,detail.validationType,2)}}
                    </p>
                  </div>
                  <div
                    :class="getClassNameTabInfoHeadlineNoDisp(service)"
                  >
                    <p>
                      {{$t("watersystem.leakage-all-normal")}}
                    </p>
                  </div>
                  <v-flex >
                    <v-btn-toggle v-model="selectLeakageEditPort" mandatory>
                      <v-btn
                        flat
                        class="port-select-btn"
                        v-for="detail in service.details"
                        :value="detail.portNumber"
                        :key="'LEAK'+detail.portNumber"
                      >
                        {{'A'+ detail.portNumber}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                  <hr class="ma-3">
                  <leakage-log
                    :data-id="filtrationSystem.filtrationSystemId + ':' + selectLeakageEditPort"
                    :selectEditPort="selectLeakageEditPort"
                    :details="service.details"
                    :timezone="selectedTimezone"
                    :activeTab="activeTab"
                    :color="getClassNameServiceStatus(service).replace('--text', '')"
                    @emit-earliest-timestamp="emitEarliestTimestamp"
                    @child-action="getFiltrationSystem"
                  >
                  </leakage-log>
                </v-container>
              </v-tab-item>

              <!-- 圧力値 ##################################-->

              <v-tab-item id="PRESS" v-if="service.serviceId === 5" reverse-transition="false" transition="false">
                <v-container class="white">
                  <div v-for="detail in service.details" >
                    <p v-if="getPluginStatus(detail)==2" >
                      <span
                        class="red--text"
                      >
                      {{'A'+detail.portNumber + ' ' + $t("sensor.pressure")+' '}}
                      </span>
                      {{getHeadlineMsg(detail.serviceId,detail.validationType,2)}}
                    </p>
                    <p v-else-if="getPluginStatus(detail)==1" >
                      <span
                        class="orange--text"
                      >
                      {{'A'+detail.portNumber + ' ' + $t("sensor.pressure")+' '}}
                      </span>
                      {{getHeadlineMsg(detail.serviceId,detail.validationType,1)}}
                    </p>
                  </div>
                  <div
                  :class="getClassNameTabInfoHeadlineNoDisp(service)"
                  >
                    <p>
                    {{$t("watersystem.headline-press-normal")}}
                    </p>
                  </div>
                   <!--圧力　ポート選択トグル-->
                  <v-flex >
                    <v-btn-toggle v-model="selectEditPort" mandatory>
                      <v-btn
                        flat
                        class="port-select-btn"
                        v-for="detail in service.details"
                        :value="detail.portNumber"
                        :key="'PRESS'+detail.portNumber"
                      >
                        {{'A'+ detail.portNumber}}
                      </v-btn>
                    </v-btn-toggle>

                    <v-btn
                      small
                      outline
                      class="lighten-2 pa-0"
                      @click="openSettingDialog(service.serviceId)"
                      :disabled="pressSettingBtnDisabled || userRole===viewerRoleName"
                    >
                      <v-icon class="body-1">settings</v-icon>&nbsp;
                      <span >{{$t('settings.title')}}</span>
                    </v-btn>
                  </v-flex>
                  <hr class="ma-3">
                  <!-- 圧力グラフ ##########################################-->
                  <water-pressure-log-chart
                    :data-id="filtrationSystem.filtrationSystemId + ':' + selectEditPort"
                    :timezone="selectedTimezone"
                    :activeTab="activeTab"
                    :color="getClassNameServiceStatus(service).replace('--text', '')"
                    :earliestLogInfo="earliestLogInfo"
                    @emit-earliest-timestamp="emitEarliestTimestamp"
                    @child-action="getFiltrationSystem"
                  >
                  </water-pressure-log-chart>
                  <div >
                    <h4>{{$t("watersystem.notification-threshold")}}</h4>
                    <table class="tab-info-table" >
                      <tr>
                        <th ></th>
                        <th >{{$t("watersystem.alert")}}</th>
                        <th >{{$t("watersystem.warning")}}</th>
                      </tr>
                      <tr v-for="detail in service.details" >
                        <td
                          v-if="detail.portNumber == selectEditPort"
                        >
                          {{$t("service.pressure")}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectEditPort"
                        >
                          {{convertPressureUnit(detail.alertRate)+' '+pressureUnit}}
                        </td>
                        <td
                          v-if="detail.portNumber == selectEditPort"
                        >
                          {{convertPressureUnit(detail.warningRate)+' '+pressureUnit}}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="setting-link-text" v-if="pressSettingBtnDisabled===false && userRole!==viewerRoleName" >
                    {{$t("watersystem.setting-link-text1")}}
                    <a
                      href="#"
                      @click="openSettingDialog(service.serviceId)"
                    >
                    {{$t("watersystem.setting-link-text2")}}
                    </a>
                    {{$t("watersystem.setting-link-text3")}}
                  </div>
                </v-container>
              </v-tab-item>

            </template>

              <!-- 履歴 ##########################################-->

              <v-tab-item id="HISTORY" reverse-transition="false" transition="false">
                <v-container>
                  <div class="mb-3">
                    <h2>{{$t("watersystem.history")}}</h2>
                  </div>
                  <v-layout v-for="hist in history" :key="hist.index">
                    <v-flex xs6>
                      <p>
                        <i class="fa" :class="historyIcon(hist.type)"></i>
                        {{unixToDatetime(hist.eventTime)}}
                      </p>
                    </v-flex>
                    <v-flex>
                      <p>{{historyTitle(hist.type)}}</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>

          </v-tabs>

          <!-- リセット ダイアログ -->
          <v-dialog
          v-model="showResetDialog"
          scrollable
          max-width="300px"
          >
            <v-card >
              <v-card-title>
                {{$t('watersystem.filter-reset-title')}}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                {{$t('watersystem.filter-reset-text')}}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="isRoot" flat @click.prevent="resetFilter" @click.native="showResetDialog = false" color="red">
                  <!-- {{$t('watersystem.filter-reset-do')}} -->
                  {{filterResetDoBtnName}}
                </v-btn>
                <v-btn small @click.native="showResetDialog = false">
                  {{$t('watersystem.filter-reset-cancel')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- 設定 ダイアログ -->
          <service-setting-dialog
            ref="childSettingDialog"
          >
          </service-setting-dialog>
        </v-flex>
    </v-layout>
    <!-- まだデータない場合の表示 -->
    <v-layout row wrap  v-else>
      <v-flex v-if="failMessage">
        <div class="pa-3">{{failMessage}}</div>
      </v-flex>
      <v-flex v-else xs12 class="white text-xs-center pt-5" id="before-select" justify-center>
        <v-icon size="70px" class="grey--text text--lighten-1">find_in_page</v-icon>
        <p>{{$t('watersystem.please-select')}}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import moment from 'moment-timezone'
import utils from '@/utils/utils.js'
import statuscheck from '@/utils/statuscheck.js'
import LeakageLog from '@/components/LeakageLog.vue'
import FlowLogChart from '@/components/FlowLogChart.vue'
import RoRateLogChart from '@/components/RoRateLogChart.vue'
import TemperatureLogChart from '@/components/TemperatureLogChart.vue'
import WaterPressureLogChart from '@/components/WaterPressureLogChart.vue'
import ServiceSettingDialog from '@/components/ServiceSettingDialog.vue'
import DeviceEditDialog from '@/components/DeviceEditDialog.vue'
import WaterSystemDeleteDialog from '@/components/WaterSystemDeleteDialog.vue'
import CsvDownloadDialog from '@/components/CsvDownloadDialog.vue'

export default {
  components: {
    LeakageLog,
    FlowLogChart,
    RoRateLogChart,
    TemperatureLogChart,
    WaterPressureLogChart,
    ServiceSettingDialog,
    DeviceEditDialog,
    WaterSystemDeleteDialog,
    CsvDownloadDialog
  },
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      viewerRoleName: config.role.Viewer,
      filtrationSystemId: null,
      location: {},
      filtrationSystem: {},
      filter: null, // TODO フィルタが１個しか付いていない前提での実装になっている。複数フィルタに対応するには実装の変更が必要。
      history: [],
      localTimezone: moment.tz.guess(),
      locationTimezone: 'UTC',
      locale: this.$store.getters.locale,
      unit: this.$store.getters.settingParams.unit,
      pressureUnit: this.$store.getters.settingParams.pressureUnit,
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      currentTab: 0,
      activeTab: null,
      serviceCodes: this.$store.getters.serviceList.codes,
      serviceNames: this.$store.getters.serviceList.longNames,
      sidebarSummaries: [],
      // メタデータ格納
      flowAndTimeMeta: null,
      failMessage: '',
      showForm: true,
      showResetDialog: false,
      selectEditPort: null, // 現在選ばれているポート番号
      selectLeakageEditPort: null,
      selectTemperatureEditPort: null,
      editData: [], // 閾値やフィルタシステムごとの設定値を変更する用途で使用する
      temperatureSettingBtnDisabled: true,
      pressSettingBtnDisabled: true,
      frowSettingBtnDisabled: true,
      roSettingBtnDisabled: true,
      earliestLogInfo: {},
      isRoot: false,
      filterResetDoBtnName: this.$t('watersystem.filter-reset-do') // フィルターチェンジボタン名
    }
  },
  methods: {
    init (filtrationSystemId) {
      this.setExecBtnProperty() // 保存ボタンの属性をセット
      if (filtrationSystemId) {
        this.filtrationSystemId = filtrationSystemId
        this.getFiltrationSystem(true)
        this.getHistory()
        this.getEarlistLog()
        moment.locale(this.locale)
        // this.updateFlowAvg()
      } else {
        // 親のwatersystem_list契機じゃない場合でもpathにあれば開いてみる
        // 開発用の画面(/watersystem/:id)への対応の意味もある
        if (this.$route.params.id) {
          this.filtrationSystemId = this.$route.params.id
          this.getFiltrationSystem(true)
          this.getHistory()
          this.getEarlistLog()
          moment.locale(this.locale)
          // this.updateFlowAvg()
        }
      }
    },
    updateFlowAvg () {
      const params = {
        'filtrationSystemId': this.filtrationSystemId
      }
      http.request('post', '/service/dashboard/api/filtration_systems/updateFlowAvg', params)
      .then(response => {
        const data = response.data
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Flow Avarage failed. (' + data.result + ')')
          return
        } else if (data.status === 304) {
          console.log('Flow Avarage doesn\'t need update. (' + data.status + ')')
          return
        }
        console.log('Flow Avarage has been updated now.(' + data.status + ')')
        return
      })
      .catch(error => {
        // TODO エラー処理
        console.log('avg update error', error)
      })
    },
    // TODO:updateConfig () 使用箇所なし HARPS-874で対応
    updateConfig () {
      // 全体のバリデーションを行う
      if (!this.$refs.settingForm.validate()) {
        // NG
        return
      }
      // 入力値を反映する
      this.updateEditData()
      const params = {
        'filtrationSystemId': this.filtrationSystemId,
        'filtrationSystemName': this.filtrationSystem.filtrationSystemName,
        'plugins': this.editData.plugins,
        'services': this.editData.services
      }
      http.request('post', '/service2/dashboard/api/FiltrationSystems/updateConfig', params)
      .then(response => {
        const data = response.data
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Config Avarage failed. (' + data.result + ')')
          // フォームを閉じる
          this.closeSettingDialog(false)
          return
        } else if (data.status === 304) {
          console.log('Config Avarage doesn\'t need update. (' + data.status + ')')
          // フォームを閉じる
          this.closeSettingDialog(false)
          return
        }
        // フォームを閉じる（成功）
        this.closeSettingDialog(true)
        return
      })
      .catch(error => {
        // TODO エラー処理
        console.log('Config update error', error)
        // フォームを閉じる
        this.closeSettingDialog(false)
      })
    },
    getFiltrationSystem (initFlg = false) {
      http.request('get', '/service2/dashboard/api/FiltrationSystems/getDetail/' + this.filtrationSystemId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get filtration system data failed. (' + data.result + ')')
            this.filtrationSystem = {}
            this.failMessage = 'Failed to get Divice Information.'
            return
          }
          if (data.device.services.length === 0) {
            console.log('Filtration system is not available.')
            this.filtrationSystem = {}
            this.failMessage = 'Filtration system is not available.'
            return
          }

          this.location = data.location
          this.locationTimezone = data.location.timezoneIdentifier
          // マルチポート対応のサービスはそのままのServicesを使うと表示がうまくできないためデータをまとめる
          data.device.dispServices = this.dispServicesAdd(data.device)
          this.filtrationSystem = data.device

          // サービスごとにMetadataのセット
          if (this.filtrationSystem) {
            this.filtrationSystem.dispServices.forEach(service => {
              switch (service.serviceId) {
                case 1:
                  // プレビュー版の名残りでfilterから交換時期等を取ってくる
                  this.filter = service.filters[0]
                  this.setFlowAndTimeMetadata()
                  break
              }
            })

            // 直前までアクティブだったタブのサービスを含まない場合
            this.$nextTick(() => {
              if (!this.hasService(this.activeTab) && this.activeTab !== 'HISTORY') {
                console.log('Change activeTab to: ' + this.serviceCodes[this.filtrationSystem.dispServices[0].serviceId])
                this.activeTab = this.serviceCodes[this.filtrationSystem.dispServices[0].serviceId]
              }
            })
            // 表示デバイスの切り替えの場合はポートを初期化
            if (initFlg === true) {
              this.setDefaultDispPort(this.filtrationSystem.dispServices)
            }
          }
          // 親のmap関数の発火
          if (this.location.latitude !== null && this.location.longitude !== null) {
            this.$emit('child-action', this.location.latitude, this.location.longitude)
          }
        })
        .catch(error => {
          // TODO エラー処理
          this.failMessage = 'Failed to get Divice Information.'
          console.log('error', error)
        })
    },
    getEarlistLog () {
      http.request('get', '/service2/dashboard/api/FiltrationSystems/getOldestLog/' + this.filtrationSystemId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get ealiest log failed. (' + data.result + ')')
            this.failMessage = 'Failed to get Earliest Log.'
            return
          }
          // PHP-7移行時の事情で、同じController名に対する同じアクション名は使えない
          // ことになったので、Action名の変更に合わせてキー名をearliest -> oldestに変更した。
          // ただし、Dashboard全般に渡って修正すると修正量が多くなるので、
          // 下記で過去のキー名earliestTimestampに変更しているる
          const converted = {
            existsLogAllServices: data.existsLogAllServices,
            earliestTimestamp: data.oldestTimestamp,
            result: data.result
          }
          this.earliestLogInfo = converted
        })
        .catch(error => {
          // TODO エラー処理
          this.failMessage = 'Failed to get Earliest Log.'
          console.log('error', error)
        })
    },
    emitEarliestTimestamp (earliestTimestamp) {
      console.log('emitEarliestTimeStamp#0')
      if (!this.earliestLogInfo.existsLogAllServices) {
        console.log('emitEarliestTimeStamp#1')
        this.earliestLogInfo.existsLogAllServices = true
        this.earliestLogInfo.earliestTimestamp = earliestTimestamp
      } else {
        console.log('emitEarliestTimeStamp#2:' + this.earliestLogInfo.earliestTimestamp + ':' + earliestTimestamp)
        if (this.earliestLogInfo.earliestTimestamp > earliestTimestamp) {
          console.log('emitEarliestTimeStamp#3')
          this.earliestLogInfo.earliestTimestamp = earliestTimestamp
        }
      }
      console.log('emitEarliestTimeStamp#9')
    },
    dispServicesAdd (data) {
      return utils.dispServicesAdd(data)
    },
    getSetting () {
      // 取得前にエディットの情報を初期化
      http.request('get', '/service2/dashboard/api/FiltrationSystems/getConfig/' + this.filtrationSystemId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get filtration system data failed. (' + data.result + ')')
            this.failMessage = 'Failed to get Divice Information.'
            return
          }
          if (data.services.length === 0) {
            console.log('Filtration system is not available.')
            this.failMessage = 'Filtration system is not available.'
            return
          }
          // 更新に必要なデータを保持
          this.editData = data
          // 各設定ボタンの無効を設定
          this.settingBtnsDisabled(this.editData.services)
        })
        .catch(error => {
          // TODO エラー処理
          this.failMessage = 'Failed to get Divice Information.'
          console.log('error', error)
        })
    },
    getHistory () {
      http.request('get', '/service2/dashboard/api/FiltrationSystemLogs/history/' + this.$route.params.id)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get history data failed. (' + data.result + ')')
            return
          }
          var shap = {
            'new': 0,
            'reset': 0,
            'flowsensor': 0,
            'iotizr': 0,
            'mail': 0
          }
          var result = []
          data.history.forEach(function (recode) {
            if (shap[recode.type] < recode.eventTime) {
              shap[recode.type] = recode.eventTime
            }
          })
          Object.keys(shap).forEach(function (key) {
            if (shap[key] !== 0) {
              var push = {
                'type': key,
                'eventTime': shap[key]
              }
              result.unshift(push)
            }
          })
          this.history = result
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    resetFilter () { // TODO filtrationSystemId, slotNumberはパラメータとして受け取るべき これではこのメソッドが this.filter に依存してしまっている
      const params = {
        'filtrationSystemId': this.$route.params.id,
        'slotNumber': this.filter.slotNumber
      }
      http.request('post', '/service2/dashboard/api/FiltrationSystems/resetFiltrationSystemFilter', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('reset filter failed. (' + data.result + ')')
            return
          }
          this.getFiltrationSystem()
          // console.log(data)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    hasService (serviceCode) {
      // 単純に表示しようとしているサービスがデバイス(システム)にあるか見る
      // idでtabを切り替えていても、前回開いたROが残ってしまったりする
      let matchSystem = this.filtrationSystem.services.filter(service => {
        return this.serviceCodes[service.serviceId] === serviceCode
      })
      return matchSystem.length >= 1 // 1つでもあればtrue
    },
    setFlowAndTimeMetadata () {
      // 寿命判断・パーセント格納
      let filterLifePercent = utils.calcFilterLifePercent(this.filter)
      let flowPercent = filterLifePercent.flow
      let timePercent = filterLifePercent.time

      // 残存洗浄可能量のステータス判断
      let flowColor = 'blue'
      if (this.filter.warningLifeSpanFlow > 0 && this.filter.flow > this.filter.warningLifeSpanFlow) {
        flowColor = 'orange'
      }
      if (this.filter.maxLifeSpanFlow > 0 && this.filter.flow > this.filter.maxLifeSpanFlow) {
        flowColor = 'red'
      }

      // 残存洗浄可能量のフォーマット出力
      let left = Math.round(this.convertUnit(this.filter.flow) * 1000) / 1000
      let max = Math.round(this.convertUnit(this.filter.maxLifeSpanFlow * 1000)) / 1000
      let leftFlowFormated = utils.numberFormatter(left, this.locale)
      let maxFlowFormated = utils.numberFormatter(max, this.locale)
      let flowLifeLeft = leftFlowFormated + '/' + maxFlowFormated + this.$store.getters.unitLabel

      // 経過時間のステータス判断
      let timeColor = 'blue'
      if (this.filter.warningLifeSpanTime > 0 && this.filter.time > this.filter.warningLifeSpanTime) {
        timeColor = 'orange'
      }
      if (this.filter.maxLifeSpanTime > 0 && this.filter.time > this.filter.maxLifeSpanTime) {
        timeColor = 'red'
      }

      if (timePercent > 100) {
        timePercent = 100
      }

      // 経過時間のフォーマット出力
      let fromNow = moment(this.filter.lastReplacementTime).diff(moment()) // ミリ秒
      let fromNowMonth = -fromNow / 60 / 60 / 24 / 30 / 1000 // ヶ月
      let maxLifeSpanMonth = this.filter.maxLifeSpanTime / 60 / 60 / 24 / 30 / 1000 // ヶ月
      let fromNowMonthRound = Math.round(fromNowMonth)
      let maxLifeSpanMonthRound = Math.round(maxLifeSpanMonth)
      // let timeContent = fromNowMonthRound + this.$t('watersystem.period-month') +
      //  ' / ' + maxLifeSpanMonthRound + this.$t('watersystem.period-month')

      this.flowAndTimeMeta = {
        // 残存洗浄可能量
        flowLifePercent: flowPercent,
        flowLifeLeft: flowLifeLeft,
        leftFlowFormated: leftFlowFormated,
        maxFlowFormated: maxFlowFormated,
        flowColor: flowColor,
        // 経過時間
        fromNowMonth: fromNowMonthRound,
        maxLifeMonth: maxLifeSpanMonthRound,
        timePercent: timePercent,
        timeColor: timeColor
      }
    },
    formatFlowLifeLeft (flow, maxLifeSpanFlow) {
      let left = Math.round(this.convertUnit(flow) * 1000) / 1000
      let max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000
      let leftNumFormated = utils.numberFormatter(left, this.locale)
      let maxNumFormated = utils.numberFormatter(max, this.locale)
      return leftNumFormated + '/' + maxNumFormated + this.$store.getters.unitLabel
    },
    nextReplacement (nextReplacementTime) {
      const options = {timeZone: this.selectedTimezone}
      return utils.dateFormatter(this.locale, nextReplacementTime, options)
    },
    unixToDatetime (unixTimestamp) {
      const options = {
        timeZone: this.selectedTimezone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
      return utils.dateFormatter(this.locale, unixTimestamp, options)
    },
    historyTitle (type) {
      // new/reset/flowsensor/iotizr
      switch (type) {
        case 'new':
          return 'New Installation'
        case 'reset':
          return 'Filter replacement'
        case 'flowsensor':
          return 'Flowsensor replacement'
        case 'iotizr':
          return 'IoTIZR replacement'
        case 'mail':
          return 'Mail notification'
        default:
          return ''
      }
    },
    historyIcon (type) {
      // new/reset/flowsensor/iotizr
      switch (type) {
        case 'new':
          return 'fa-link'
        case 'reset':
          return 'fa-refresh'
        case 'flowsensor':
          return 'fa-refresh'
        case 'iotizr':
          return 'fa-refresh'
        case 'mail':
          return 'fa-envelope'
        default:
          return ''
      }
    },
    getClassNameTabInfoHeadlineNoDisp (service) {
      if (statuscheck.getServiceStatusValue(service) === 0) {
        return ''
      }
      return 'tab-info-headline-no-disp'
    },
    getClassNameServiceStatus (service) {
      return statuscheck.getCssClassForStatus(statuscheck.getServiceStatusValue(service), '--text')
    },
    getClassNamePluginStatus (detail) {
      var alertClass = 'red--text'
      var warningClass = 'orange--text'
      var goodClass = 'blue--text'
      switch (detail.status) {
        case 0:
          return goodClass
        case 1:
          return warningClass
        case 2:
          return alertClass
        default:
          return goodClass
      }
    },
    getServiceStatus (service) {
      return statuscheck.getServiceStatusValue(service)
    },
    getPluginStatus (detail) {
      return statuscheck.getPluginStatusValue(detail)
    },
    getHeadlineMsg (serviceId, validationType, statusCode) {
      // statusCode 0:normal 1:warning 2:alert
      var msg = ''
      if (serviceId === 3) {
        if (validationType === 1) {
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-temperature-up-alert')
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-temperature-up-warning')
          }
        } else if (validationType === 2) {
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-temperature-down-alert')
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-temperature-down-warning')
          }
        }
      }
      if (serviceId === 4) {
        if (statusCode === 2) {
          msg = this.$t('watersystem.headline-leakage-alert')
        }
      }
      if (serviceId === 5) {
        if (validationType === 1) {
          // 差圧
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-diff-press-alert')
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-diff-press-warning')
          }
        } else {
          // 圧力値
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-press-alert')
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-press-warning')
          }
        }
      }
      return msg
    },
    convertUnit (flow) {
      return utils.convertUnit(flow, this.unit)
    },
    convertSecondToMonth (second) {
      return utils.convertSecondToMonth(second)
    },
    convertPressureUnit (pressure) {
      return utils.convertPressureUnit(pressure, this.pressureUnit)
    },
    convertTemperatureUnit (temperature) {
      return utils.convertTemperatureUnit(temperature, this.temperatureUnit)
    },
    convertMaxLifeSpanFlow (maxLifeSpanFlow) {
      let max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000
      let maxNumFormated = utils.numberFormatter(max, this.locale)
      return maxNumFormated
    },
    openSettingDialog (serviceId) {
      var params = this.createSettingDialogParams(serviceId)
      if (serviceId === 1) {
        params.selectEditPort = this.selectEditPort
      } else if (serviceId === 2) {
        params.selectEditPort = this.selectLeakageEditPort
      } else if (serviceId === 3) {
        params.selectEditPort = this.selectTemperatureEditPort
      } else if (serviceId === 4) {
        params.selectEditPort = this.selectEditPort
      } else if (serviceId === 5) {
        params.selectEditPort = this.selectEditPort
      }
      console.log(params)
      this.$refs.childSettingDialog.openSettingDialog(params)
    },
    // 子フォームで使用するパラメータを作成
    createSettingDialogParams (serviceId) {
      return {
        selectEditServiceId: serviceId,
        locationName: this.location.locationName,
        filtrationSystemName: this.filtrationSystem.filtrationSystemName,
        filtrationSystemId: this.filtrationSystemId,
        editData: this.editData
      }
    },
    settingBtnsDisabled (services) {
      for (var i = 0; i < services.length; i++) {
        this.settingBtnDisabled(services[i])
      }
    },
    settingBtnDisabled (service) {
      // TODO プリセット編集機能ができたら外す
      if (service.serviceId === 1) {
        if (service.params.presetId === null) {
          this.frowSettingBtnDisabled = false
          return
        }
      } else if (service.serviceId === 2) {
        if (service.params.roPresetId === null) {
          this.roSettingBtnDisabled = false
          return
        }
      } else if (service.serviceId === 3) {
        if (service.params.triggerParamId === null) {
          this.temperatureSettingBtnDisabled = false
          return
        }
      } else if (service.serviceId === 5) {
        if (service.params.triggerParamId === null) {
          this.pressSettingBtnDisabled = false
          return
        }
      }
    },
    setDefaultDispPort (services) {
      // 圧力タブのデフォルト表示ポートを設定する
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 5) {
          if (services[i].details.length > 0) {
            this.selectEditPort = services[i].details[0].portNumber
            return
          }
        } else if (services[i].serviceId === 4) {
          if (services[i].details.length > 0) {
            this.selectLeakageEditPort = services[i].details[0].portNumber
            return
          }
        } else if (services[i].serviceId === 3) {
          if (services[i].details.length > 0) {
            this.selectTemperatureEditPort = services[i].details[0].portNumber
            return
          }
        }
      }
    },
    openDeviceEditDialog () {
      let params = {
        'filtrationSystemId': this.filtrationSystemId
      }
      this.$refs.deviceEditDialog.startDialog(params)
    },
    showWaterSystemDeleteDialog (device) {
      this.$refs.waterSystemDeleteDialog.startDialog(device)
    },
    reloadWaterSystemList (filtrationSystemId) {
      this.$router.push('/watersystem_list/')
      this.$emit('delete-succeed', this.filtrationSystemId)
    },
    // 保存ボタンの属性をセットする
    setExecBtnProperty () {
      this.isRoot = utils.isRoot(this.$store.getters.user.roles) // ルートかどうかを判定
      if (this.isRoot) {
        this.filterResetDoBtnName = this.$t('aplix-use-only.btn.can-not-execute')
      }
    }
  },
  watch: {
    filtrationSystemId () {
      this.getSetting()
    }
  },
  computed: {
    selectedTimezone () {
      if (this.$store.getters.settingParams.timezone === 'utc') {
        return 'UTC'
      } else if (this.$store.getters.settingParams.timezone === 'local') {
        return this.localTimezone
      } else if (this.$store.getters.settingParams.timezone === 'location') {
        return this.locationTimezone
      }
      return 'UTC'
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
#device-name {
  height: 90px;
}
#sidebar hr, #watersystem-tab hr{
  border-top: 1px solid #CCC;
  border-bottom: 0px;
}

#sidebar {
  border-right: 4px #D0D5E2 solid !important;
}

#watersystem-tab .tabs__item--active {
  background-color: #FFF !important;
  font-weight: bold;
}
.tabs__container {
  background-color: #EEE !important;
}

#PRESS .tabs__container {
  background-color: white !important;
  border-bottom: 1px solid #CCC;
}

#PRESS .port-select-btn {
  width:50px;
}

#before-select {
  height: 455px;
}

#watersystem-tab .progress-linear__bar__determinate {
    border-radius: 3px;
}

.tabs__item {
  opacity: 1;
}

#location #address li:before {
  font-family: FontAwesome;
  content: '\f041';
  margin-right: 0.5em;
}

#location #phone li:before {
  font-family: FontAwesome;
  content: '\f095';
  margin-right: 0.5em;
}

#location #contact li:before {
  font-family: FontAwesome;
  content: '\f003';
  margin-right: 0.5em;
}

#location li {
  text-indent:-1em;
  padding-left:1em;
}

.tab-info-table {
  width: 100%;
  border-collapse: collapse;
}

.tab-info-table th  {
  background-color: lightgray;
}
.tab-info-table td , th {
  border: 1px solid lightgray;
  border-left-style:none;
  border-right-style:none;
  height: 40px;
  text-align: center;
  vertical-align: middle;
}

.tab-info-headline-no-disp{
  display:none;
}

.setting-link-text{
  margin: 10px;
}

.device-setting-btn{
  float: right;
}

</style>



// WEBPACK FOOTER //
// WaterSystem.vue?39319b7d